import React from 'react';
import { useSupport } from '../../contexts/SupportContext';
import type { Role } from '../../shared/permissions';
import { CustomSelect } from '../../shared/components/CustomSelect';
import './SupportBanner.css';

export function SupportBanner() {
  const { supportMode, targetOrg, effectiveRole, switchRole, exitSupportMode } = useSupport();

  if (!supportMode || !targetOrg) return null;

  return (
    <div className="support-banner">
      <div className="support-banner-left">
        <span className="support-banner-badge">SUPPORT</span>
        <span className="support-banner-org">{targetOrg.display_name || targetOrg.name}</span>
      </div>
      <div className="support-banner-right">
        <CustomSelect
          value={effectiveRole}
          options={[
            { value: 'owner', label: 'Owner' },
            { value: 'administrator', label: 'Administrator' },
            { value: 'member', label: 'Member' },
          ]}
          onChange={(val) => switchRole(val as Role)}
        />
        <button className="support-banner-exit" onClick={exitSupportMode}>
          Exit support mode
        </button>
      </div>
    </div>
  );
}
